<template>
  <div>
    <h3 class="vap-form__section-title">AWS Authentication</h3>
    <div class="form-row">
      <VasionInput
        id="guardrail-name"
        v-model="formFields.name"
        title="Amazon Bedrock Guardrail Name"
        name="guardrail-name"
        placeholder="Amazon Bedrock Guardrail Name..."
        inputType="top-white"
        required
        :autoFocus="true"
        @input="emitWrapperIsDirty"
      />
    </div>
    <div class="form-row">
      <VasionInput
        id="aws-access-key-id"
        v-model="formFields.awsAccessKeyID"
        title="AWS Access Key ID"
        name="aws-access-key-id"
        placeholder="AWS Access Key ID..."
        inputType="top-white"
        required
        @input="emitWrapperIsDirty"
      />
      <VasionInput
        id="aws-secret-key"
        v-model="formFields.awsSecretKey"
        title="AWS Secret Key"
        name="aws-secret-key"
        type="password"
        placeholder="AWS Secret Key..."
        inputType="top-white"
        required
        preventPasswordAutofill
        preventNewPassword
        @input="emitWrapperIsDirty"
      />
      <VasionButton
        :classProp="'primary'"
        :isDisabled="!isNameAndAwsConnectionPresent"
        class="btn-margin-fix"
        @vasionButtonClicked="validateAwsCredentials()"
      >
        Validate
      </VasionButton>
    </div>
    <h3 class="vap-form__section-title">AWS Configuration</h3>
    <div class="form-row">
      <VasionDropList
        v-slot="slotItem"
        v-model="formFields.awsRegion"
        title="AWS Region"
        :dataArray="lists.awsRegions"
        width="100%"
        :showSearchField="true"
        type="plain-list"
        displayName="displayName"
        valueName="value"
        :required="true"
        :isDisabled="!isAwsAuthValid"
        :showIfEmpty="true"
        @input="
          emitWrapperIsDirty()
          getAwsBuckets()
        "
      >
        {{ slotItem.item.displayName }}
      </VasionDropList>
      <VasionDropList
        v-slot="slotItem"
        v-model="formFields.awsBucket"
        title="AWS Bucket"
        :dataArray="lists.awsBuckets"
        width="100%"
        :showSearchField="true"
        type="plain-list"
        displayName="displayName"
        valueName="value"
        :required="true"
        :showIfEmpty="true"
        :isDisabled="!(isAwsRegionPresent && !isAwsBucketListEmpty)"
        @input="emitWrapperIsDirty"
      >
        {{ slotItem.item.displayName }}
      </VasionDropList>
      <VasionButton
        :classProp="'primary'"
        :isDisabled="!isAwsRegionAndBucketSelected"
        class="btn-margin-fix"
        @vasionButtonClicked="getAwsGuardrails"
      >
        Validate
      </VasionButton>
    </div>
    <div class="form-row">
      <VasionDropList
        v-slot="slotItem"
        v-model="formFields.guardrail"
        title="AWS Bedrock Guardrail"
        :dataArray="lists.awsGuardrails"
        width="100%"
        :showSearchField="true"
        type="plain-list"
        displayName="displayName"
        valueName="value"
        :required="true"
        :isDisabled="isAwsGuardrailsEmpty"
        :showIfEmpty="true"
        @input="emitWrapperIsDirty()"
      >
        {{ slotItem.item.displayName }}
      </VasionDropList>
    </div>
    <h3 class="vap-form__section-title">Process Configuration</h3>
    <div class="form-row">
      <VasionDropList
        v-slot="slotItem"
        v-model="formFields.object"
        title="Object"
        :dataArray="lists.objects"
        width="100%"
        :showSearchField="true"
        type="plain-list"
        displayName="name"
        valueName="value"
        :required="true"
        :showIfEmpty="true"
        :isDisabled="!isGuardrailSelected"
        @input="
          emitWrapperIsDirty()
          onObjectChanged()
        "
      >
        {{ slotItem.item.name }}
      </VasionDropList>
      <VasionDropList
        v-slot="slotItem"
        v-model="formFields.fieldId"
        title="Object Results Field"
        width="100%"
        type="plain-list"
        displayName="title"
        valueName="id"
        :dataArray="objectFields"
        :showSearchField="false"
        :required="true"
        :showIfEmpty="true"
        :isDisabled="!isObjectSelected"
        @input="emitWrapperIsDirty"
      >
        {{ slotItem.item.title }}
      </VasionDropList>
    </div>
    <VasionSnackbar
      id="snackbar-bedrock-guardrail-form"
      ref="bedrockGuardrailSnackbar"
      :showSnackbarBool.sync="snackbar.showSnackbar"
      :snackbarImage="snackbar.snackbarImage"
      :snackbarSubTitle="snackbar.snackbarSubTitle"
      :snackbarTitle="snackbar.snackbarTitle"
    />
  </div>
</template>

<script>
export default {
  name: 'BedrockGuardrailForm',
  components: {},
  props: {
    guardrailDataToEdit: {
      type: Object,
      required: false,
      default: null,
    },
  },
  data() {
    return {
      awsAIPGuardrailType: 3,
      dataToEdit: this.guardrailDataToEdit,
      forceOpenGuardrailsDroplist: false,
      formFields: {
        awsAccessKeyID: '',
        awsBucket: '',
        awsRegion: '',
        awsSecretKey: '',
        fieldId: null,
        guardrail: null,
        name: '',
        object: '',
      },
      isAwsAuthValid: false,
      isInitializingEdit: false,
      lists: {
        awsBuckets: [],
        awsGuardrails: [],
        awsRegions: [],
        objects: [],
      },
      snackbar: {
        showSnackbar: false,
        snackbarImage: false,
        snackbarSubTitle: '',
        snackbarTitle: '',
      },
    }
  },
  computed: {
    isAwsBucketListEmpty() {
      return this.lists.awsBuckets.length === 0
    },
    isAwsGuardrailsEmpty() {
      return this.lists.awsGuardrails.length === 0
    },
    isAwsRegionAndBucketSelected() {
      return Boolean(
        this.formFields.awsRegion?.value && this.formFields.awsBucket?.value
      )
    },
    isAwsRegionPresent() {
      return Boolean(this.formFields.awsRegion?.value)
    },
    isEdit() {
      return this.dataToEdit && 'Id' in this.dataToEdit
    },
    isFieldIdSelected() {
      return Boolean(this.formFields.fieldId?.id)
    },
    isGuardrailSelected() {
      return Boolean(this.formFields.guardrail?.value)
    },
    isTheFormValid() {
      let formValid = this.isNameAndAwsConnectionPresent
      formValid = formValid && this.isAwsRegionAndBucketSelected
      formValid = formValid && this.isGuardrailSelected
      formValid = formValid && this.isObjectSelected
      formValid = formValid && this.isFieldIdSelected

      return formValid
    },
    isNameAndAwsConnectionPresent() {
      return Boolean(
        this.formFields.name &&
          this.formFields.awsAccessKeyID &&
          this.formFields.awsSecretKey
      )
    },
    isObjectSelected() {
      return Boolean(this.formFields.object?.value)
    },
    objectFields() {
      let objectFields = []
      const fieldNamesToIgnore = [
        'Workflow_Status',
        'Workflow_Approver',
        'Workflow_Due_Date',
        'Workflow_Initiator',
        'CreatedBy',
      ]
      const fields =
        this.$store.state.attributeForm.activeIndexForm.fields || []

      fields
        .filter(field => !fieldNamesToIgnore.includes(field.name))
        .map(field => {
          objectFields.push({
            id: field.fieldID,
            name: field.name,
            title: field.title,
          })
        })

      return objectFields
    },
  },
  watch: {
    guardrailDataToEdit(newValue) {
      this.dataToEdit = newValue
      if (
        this.isEdit &&
        Object.keys(this.dataToEdit).length &&
        !this.isInitializingEdit
      )
        this.setFormValues(this.dataToEdit)
    },
  },
  async created() {
    this.$emit('markLoadingStatus', true)
    this.lists.awsRegions = await this.getAwsRegions()
    this.lists.objects = await this.$store.dispatch('attributeForm/getForms')

    if (
      this.isEdit &&
      Object.keys(this.dataToEdit).length &&
      !this.isInitializingEdit
    )
      await this.setFormValues(this.dataToEdit)
    this.$emit('markLoadingStatus', false)
  },
  methods: {
    delay(ms) {
      return new Promise(resolve => setTimeout(resolve, ms))
    },
    emitWrapperIsDirty() {
      const formValid = this.isTheFormValid

      this.$emit('markAsDirty')
      this.$emit('markFormStatus', formValid)
    },
    async getAwsBuckets(calledFromRegionSelection = true) {
      if (!this.formFields.awsRegion?.value) {
        this.formFields.awsBucket = []
        this.lists.awsBuckets = []
        return
      }

      if (calledFromRegionSelection) this.$emit('markLoadingStatus', true)

      const payload = {
        ...(this.isEdit && { id: this.dataToEdit.Id }),
        awsAccessKeyID: this.formFields.awsAccessKeyID,
        awsSecretKey: this.formFields.awsSecretKey,
        awsRegion: this.formFields.awsRegion.value,
        amazonType: this.awsAIPGuardrailType,
      }

      const response = await this.$store.dispatch(
        'admin/listTextractS3Buckets',
        payload
      )
      let awsBuckets = response?.buckets || []

      awsBuckets = awsBuckets.map(awsBucket => ({
        value: awsBucket,
        displayName: awsBucket,
      }))
      this.lists.awsBuckets = awsBuckets

      this.formFields.awsBucket = []

      if (awsBuckets.length === 0) {
        const title = 'AWS Region'
        const subTitle = 'There are no buckets associated with this region'
        this.showSnackbar(title, subTitle, false)
      } else {
        this.$refs.bedrockGuardrailSnackbar.closeSnackbar()
      }

      if (calledFromRegionSelection) this.$emit('markLoadingStatus', false)
    },
    async getAwsGuardrails(calledFromRegionSelection = true) {
      if (
        !this.formFields.awsAccessKeyID ||
        !this.formFields.awsSecretKey ||
        !this.formFields.awsRegion
      ) {
        this.lists.awsGuardrails = []
        return
      }

      if (calledFromRegionSelection) this.$emit('markLoadingStatus', true)

      const payload = {
        ...(this.isEdit && { id: this.dataToEdit.Id }),
        awsAccessKeyID: this.formFields.awsAccessKeyID,
        awsSecretKey: this.formFields.awsSecretKey,
        awsRegion: this.formFields.awsRegion?.value,
      }

      const response = await this.$store.dispatch(
        'admin/listGuardrails',
        payload
      )

      const isValid = Boolean(response && response?.Values)
      const title = 'AWS Bedrock Guardrails'
      const subTitle = isValid
        ? 'AWS Bedrock Guardrails successfully validated'
        : response?.ResultMessage ||
          'Invalid AWS configuration. Please contact your administrator.'

      if (calledFromRegionSelection) this.showSnackbar(title, subTitle, isValid)

      let awsGuardrails = response?.Values || []
      awsGuardrails = awsGuardrails.map(awsGuardrail => ({
        value: awsGuardrail.key,
        displayName: awsGuardrail.value,
      }))
      this.lists.awsGuardrails = awsGuardrails

      if (awsGuardrails.length === 0) {
        const title = 'AWS Guardrails'
        const subTitle =
          'There are no Guardrails associated with this AWS account'
        this.showSnackbar(title, subTitle, false)
      }

      if (calledFromRegionSelection) this.$emit('markLoadingStatus', false)
    },
    async getAwsRegions() {
      const response = await this.$store.dispatch('admin/getAwsRegions')
      let regions = []
      if (response && response?.data.Values) {
        regions = await response.data.Values.map(region => ({
          value: region,
          displayName: region,
        }))
      }
      return regions
    },
    async getObjectFields(objectId) {
      await this.$store.dispatch('attributeForm/getFormDetails', objectId)
    },
    onObjectChanged() {
      this.formFields.fieldId = null
      this.emitWrapperIsDirty()
      this.getObjectFields(this.formFields.object.value)
    },
    async setFormValues(data) {
      const validData = this.validateDataToEdit(data)
      if (!validData) {
        return
      }
      this.isInitializingEdit = true
      // AWS Authentication
      this.formFields.awsAccessKeyID = data.AwsConfig.ClientID
      this.formFields.awsSecretKey = data.AwsConfig.ClientSecret
      this.formFields.name = data.Name
      this.isAwsAuthValid = true
      // AWS Configuration
      const awsRegionsLoaded = await this.waitForArrayValues(
        () => this.lists.awsRegions
      )
      if (!awsRegionsLoaded && this.lists.awsRegions.length === 0) {
        this.$emit('markLoadingStatus', false)
        const title = 'AWS Rekonition'
        const subTitle = 'Failed to load AWS regions. Please try again later.'
        this.showSnackbar(title, subTitle, false)
        return
      }
      this.formFields.awsRegion = await this.lists.awsRegions.find(
        item => item.value === data.AwsConfig.Region
      )

      await this.getAwsBuckets(false)
      this.formFields.awsBucket = await this.lists.awsBuckets.find(
        item => item.value === data.AwsConfig.BucketName
      )

      await this.getAwsGuardrails(false)
      this.formFields.guardrail = await this.lists.awsGuardrails.find(
        item => item.value === data.GuardrailId
      )

      this.formFields.object = await this.lists.objects.find(
        item => item.value === data.IndexFormId
      )

      await this.getObjectFields(this.formFields.object.value)
      this.formFields.fieldId = await this.objectFields.find(
        item => item.id === data.FieldID
      )

      this.isInitializingEdit = false
    },
    showSnackbar(title, subTitle, image) {
      this.snackbar = {
        snackbarTitle: title,
        snackbarSubTitle: subTitle,
        snackbarImage: image,
        showSnackbar: true,
      }
    },
    async validateAwsCredentials() {
      this.$emit('markLoadingStatus', true)
      const payload = {
        ...(this.isEdit && { id: this.dataToEdit.Id }),
        awsAccessKeyID: this.formFields.awsAccessKeyID,
        awsSecretKey: this.formFields.awsSecretKey,
        amazonType: this.awsAIPGuardrailType,
      }
      const response = await this.$store.dispatch(
        'admin/validateTextractConnection',
        payload
      )
      this.$emit('markLoadingStatus', false)

      const isValid = response && response.Value === 'True'
      this.isAwsAuthValid = isValid
      const title = 'AWS Connection'
      const subTitle = isValid
        ? 'AWS account successfully validated'
        : response?.ResultMessage ||
          'Invalid AWS account. Please contact your administrator.'
      this.showSnackbar(title, subTitle, isValid)
    },
    async validateDataToEdit(data) {
      if (!data || typeof data !== 'object') {
        return false
      }
      const requiredFields = [
        'Id',
        'Name',
        'GuardrailId',
        'GuardrailName',
        'AwsConfig.Region',
        'AwsConfig.BucketName',
        'AwsConfig.ClientID',
        'AwsConfig.ClientSecret',
        'IndexFormId',
        'FieldID',
      ]

      for (const field of requiredFields) {
        if (!Object.prototype.hasOwnProperty.call(data, field)) {
          return false
        }
      }

      return true
    },
    async waitForArrayValues(getArray, timeout = 5000, interval = 50) {
      const start = Date.now()
      while (getArray().length === 0) {
        if (Date.now() - start > timeout) {
          return false
        }
        await this.delay(interval)
      }
      return true
    },
  },
}
</script>

<style lang="scss" scoped>
@import '@/assets/css/variables.scss';

.vap-form__section-title {
  font-size: 18px;
  margin-bottom: 0px;
  padding-left: 6px;
}
div.form-row {
  padding: 6px;
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(320px, 1fr));
  grid-gap: 8px;
  margin-top: 8px;
  margin-bottom: 8px;
}
::v-deep .btn-margin-fix button {
  margin-left: 0px;
}
@media (min-width: $breakpoint-xl) {
  .btn-margin-fix {
    position: relative;
    top: 17px;
  }
}
</style>
